import { createApp } from "vue";
import App from "./App.vue";
import PrimeVue from "primevue/config";
import Button from "primevue/button";
import * as VueRouter from "vue-router";
import { isNavigationFailure } from 'vue-router'
import { createI18n } from "vue-i18n";
import fr from "./languages/fr";
import frPrimevue from "./languages/fr-primevue";
import { createPinia } from "pinia";

// from primevue/resources/themes/nova-vue/theme.css
import "./assets/css/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";

import "./assets/css/main.css";
import "./assets/css/responsive.css";

import ToastService from "primevue/toastservice";
import Toast from "primevue/toast";
import RadioButton from "primevue/radiobutton";
import InputText from "primevue/inputtext";
import Dropdown from "primevue/dropdown";
import Image from "primevue/image";
import Tooltip from "primevue/tooltip";
import Calendar from "primevue/calendar";
import Card from "primevue/card";
import Textarea from 'primevue/textarea';
import FileUpload from 'primevue/fileupload';

import StepIntervention from "./components/StepIntervention";
import StepParebrise from "./components/StepParebrise";
import StepCar from "./components/StepCar";
import StepClient from "./components/StepClient";
import StepAppointment from "./components/StepAppointment";
import StepSides from "./components/StepSides";
import StepDescaling from "./components/StepDescaling";
import StepReplaceOrRepair from "./components/StepReplaceOrRepair";
import StepQuoteOrAppointment from "./components/StepQuoteOrAppointment";
import StepQuoteConfirm from "./components/StepQuoteConfirm";
import StepAppointmentConfirm from "./components/StepAppointmentConfirm";
import StepCheckInformation from "./components/StepCheckInformation";

document.addEventListener("DOMContentLoaded", function () {
  const routes = [
    { path: "/", redirect: "/intervention" },
    { path: "/intervention", component: StepIntervention },
    { path: "/pare-brise", component: StepParebrise },
    { path: "/mon-vehicule", component: StepCar },
    { path: "/mes-coordonnees", component: StepClient },
    { path: "/mon-rendez-vous", component: StepAppointment },
    { path: "/cote-concerne", component: StepSides },
    { path: "/decalaminage", component: StepDescaling },
    { path: "/pare-brise-description", component: StepReplaceOrRepair },
    { path: "/devis-ou-rendez-vous", component: StepQuoteOrAppointment },
    { path: "/devis-confirme", component: StepQuoteConfirm },
    { path: "/rendez-vous-confirme", component: StepAppointmentConfirm },
    { path: "/verifier-mes-informations", component: StepCheckInformation },
  ];

  const router = VueRouter.createRouter({
    history: VueRouter.createWebHashHistory(),
    routes,
  });

  router.afterEach((to, from, failure) => {
    if (!isNavigationFailure(failure)) {
      let pageCategory3 = "";
      switch (to.path) {
        case "/intervention": pageCategory3 = "etape1"; break;
        case "/pare-brise": pageCategory3 = "etape2"; break;
        case "/pare-brise-description": pageCategory3 = "etape2.1"; break;
        case "/cote-concerne": pageCategory3 = "etape2"; break;
        case "/decalaminage": pageCategory3 = "etape2"; break;
        case "/mon-vehicule": pageCategory3 = "etape3"; break;
        case "/mes-coordonnees": pageCategory3 = "etape4"; break;
        case "/devis-ou-rendez-vous": pageCategory3 = "etape4.1"; break;
        case "/mon-rendez-vous": pageCategory3 = "etape5"; break;
        case "/verifier-mes-informations": pageCategory3 = "etape6"; break;
        case "/rendez-vous-confirme": pageCategory3 = "validation"; break;
        case "/devis-confirme": pageCategory3 = "validation"; break;
      }

      if (pageCategory3) {
        const dataLayerToPush = {
          'envWork': process.env.VUE_APP_ENV,
          'language': 'fr',
          'userAuthenticated': 0,
          'event' : 'page',
          'pageName' : '/prise-de-rendez-vous/#' + to.path,
          'pageCategory1' : 'rdv',
          'pageCategory2' : 'formulaire',
          'pageCategory3' : pageCategory3,
        };

/*        //remove data from datalayer when going on previous steps
        switch (to.path) {
          case "/intervention": 
            dataLayerToPush.intervention = undefined;
            // falls through
          case "/pare-brise": 
            dataLayerToPush.windshield_damage = undefined;
            dataLayerToPush.windshield_reparation = undefined;
            // falls through
          case "/pare-brise-description": 
            dataLayerToPush.windshield_reparation = undefined;
            // falls through
          case "/cote-concerne": 
            dataLayerToPush.intervention_side = undefined;
            // falls through
          case "/decalaminage": 
            dataLayerToPush.descaling_option = undefined;
            // falls through
          case "/mon-vehicule": 
            dataLayerToPush.numberplate = undefined;
            dataLayerToPush.car_model_name = undefined;
            dataLayerToPush.brand_id = undefined;
            dataLayerToPush.car_model_id = undefined;
            dataLayerToPush.brand_name = undefined;
            dataLayerToPush.other_brand_name = undefined;
            // falls through
          case "/mes-coordonnees": 
            dataLayerToPush.firstname = undefined;
            dataLayerToPush.lastname = undefined;
            dataLayerToPush.phone = undefined;
            dataLayerToPush.email = undefined;
            dataLayerToPush.additional_information = undefined;
            // falls through
          case "/devis-ou-rendez-vous": 
          case "/mon-rendez-vous": 
            dataLayerToPush.appointment_date = undefined;
            dataLayerToPush.appointment_time = undefined;
            dataLayerToPush.point_of_sale_id = undefined;
            dataLayerToPush.other_point_of_sale_name = undefined;
            // falls through
          case "/verifier-mes-informations": 
          case "/rendez-vous-confirme": 
          case "/devis-confirme": 
        }*/

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(dataLayerToPush);
      }
    }
  })

  const i18n = createI18n({
    locale: "fr",
    messages: {
      fr,
    },
  });

  const app = createApp(App);

  app.use(createPinia());
  app.use(router);
  app.use(i18n);
  app.use(PrimeVue, {
    locale: frPrimevue,
  });
  app.use(ToastService);
  app.component("Button", Button);
  app.component("Toast", Toast);
  app.component("RadioButton", RadioButton);
  app.component("InputText", InputText);
  app.component("Dropdown", Dropdown);
  app.component("Image", Image);
  app.component("Calendar", Calendar);
  app.component("Card", Card);
  app.component("Textarea", Textarea);
  app.component("FileUpload", FileUpload);
  app.directive("tooltip", Tooltip);
  app.mount("#appointment-module");
});
